export const customerAccessTextKey = 'CustomerAccess';

export type CustomerAccessText = {
    UnavailableCustomerSummary: string;
    UnavailableCustomerDetail: string;
};
